import { assetUrl } from "fusion-core";

export const overrideFontStyles = `
  @font-face {
    font-family: 'UberMoveTextRegular';
    src: url(${assetUrl("../../assets/font/UberMoveTextRegular.otf")}) format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'UberMoveBold';
    src: url(${assetUrl("../../assets/font/UberMoveBold.otf")}) format('opentype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'UberMoveTextMedium';
    src: url(${assetUrl("../../assets/font/UberMoveMedium.otf")}) format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  body {
    font-family: 'UberMoveTextRegular', sans-serif;
  }

  button {
    font-family: 'UberMoveTextRegular', sans-serif;
  }

  h1, h2 {
    margin-top: 0;
    font-family: 'UberMoveBold', sans-serif;
  }

  h3, h4 {
    font-family: 'UberMoveBold', sans-serif;
  }

  p {
    font-family: 'UberMoveTextRegular', sans-serif;
  }
`;
